import api from "utils/axios";

export async function login(rememberMe, email, password) {
  try {
    const response = await api.post(`${process.env.REACT_APP_BASE_URL}/auth/login`, {
      email,
      password,
    });

    if (response.data.success === true) {
      const result = response.data.data;
      if (rememberMe) {
        localStorage.setItem("email", email);
        localStorage.setItem("rememberMe", "true");
      } else {
        sessionStorage.setItem("email", email);
        localStorage.setItem("rememberMe", "false");
      }
      localStorage.setItem("token", result.accessToken);
      window.location.href = "/dashboard";
      return true;
    }

    throw new Error(response.data.message || "Login failed");
  } catch (error) {
    throw error;
  }
}

export async function logout() {
  try {
    const response = await api.post(`${process.env.REACT_APP_BASE_URL}/auth/logout`);
    if (response.data.success !== true) {
      throw new Error(response.data.message || "Logout failed");
    }
  } catch (error) {
    console.error(error);
    throw error;
  } finally {
    localStorage.removeItem("token");
    window.location.href = "/authentication/sign-in";
  }
}
